import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import MenuRounded from '@mui/icons-material/MenuRounded'
import classNames from 'classnames'
import { useIsAuth } from 'feature/auth/hooks'
import { Menu } from 'feature/menu'
import { useState } from 'react'
import { Link, Drawer, Button, IconButton } from 'ui'

import style from './Header.module.scss'

// шапка сайта
export function Header() {
  const [isActive, setActive] = useState(false)
  const isAuth = useIsAuth()

  const toggleDrawer = (open: boolean) => {
    setActive(open)
  }

  return (
    <div className='container'>
      <header className={classNames(style.header, 'pt24 pb24')}>
        <Link href='/' className={style.logoLink}>
          <img src='/images/logo-header.svg' alt='DoorHan logo' />
        </Link>

        {isAuth && (
          <IconButton
            onClick={() => setActive(true)}
            className={style.burgerMenuIcon}
          >
            <MenuRounded />
          </IconButton>
        )}

        {!isAuth && (
          <>
            <Link href='/' className={style.homeLink}>
              <Button
                color='secondary'
                variant='contained'
                size='large'
                startIcon={<HomeRoundedIcon className={style.btnIcon} />}
                className={classNames('mobile-hidden', style.homeBigBtn)}
              >
                Главная
              </Button>
              <IconButton className={style.iconButton}>
                <HomeRoundedIcon
                  className={classNames(
                    style.btnIcon,
                    'desktop-hidden',
                    'tablet-hidden',
                  )}
                />
              </IconButton>
            </Link>
          </>
        )}
      </header>
      <Drawer
        anchor='right'
        open={isActive}
        onClose={() => toggleDrawer(false)}
      >
        <Menu handleChange={() => toggleDrawer(false)} />
      </Drawer>
    </div>
  )
}
